/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SupportRequestPayload } from '../models/SupportRequestPayload';
import type { SupportRequestResponse } from '../models/SupportRequestResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SupportRequestService {

    /**
     * Submit an in-app support request
     * Accepts a support request together with the context the client captured at the point of failure, and emails it to Bettercomp support. Zendesk creates the ticket from that email and attaches it to the correct customer organisation via the reply-to address, which the server sets to the authenticated user.
     *
     * Nothing is persisted. The response acknowledges that the request was accepted and emailed, and returns a correlation id that also appears in the email body.
     *
     * Any authenticated user may call this — support is not gated behind a permission.
     *
     * Identity fields are set from the authenticated session and rejected if sent by the client. See `SupportRequestPayload`.
     * @returns SupportRequestResponse Accepted. The request was validated and the email was handed to the mail transport.
     * @throws ApiError
     */
    public static createSupportRequest({
        requestBody,
    }: {
        requestBody: SupportRequestPayload,
    }): CancelablePromise<SupportRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/support-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                503: `The specified resource is unavailable`,
            },
        });
    }

}
